import { Button } from '@chakra-ui/react';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { colors } from 'packages/common-frontend/colors';
import { SaveIconButton } from 'packages/common-frontend/components/IconButton';
import {
  UpdateCreditAgreementFullArtifactWipMutationFnGQLType,
  UpdateLenderCreditAgreementFullArtifactWipMutationFnGQLType,
} from 'packages/creditAgreements/requests/requests.gql.generated';

type SaveCreditAgreementWipButtonProps = {
  creditAgreementFullArtifactWip: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
  isDisabled: boolean;
  saveCreditAgreementFullArtifactWip:
    | UpdateLenderCreditAgreementFullArtifactWipMutationFnGQLType
    | UpdateCreditAgreementFullArtifactWipMutationFnGQLType;
  isSaveCreditAgreementFullArtifactWipLoading: boolean;
  operationMode: CreditAgreement.OperationMode;
  isCommitAllowed?: boolean;
};
export const SaveCreditAgreementWipButton = ({
  creditAgreementFullArtifactWip,
  saveCreditAgreementFullArtifactWip,
  isDisabled,
  isSaveCreditAgreementFullArtifactWipLoading,
  operationMode,
  isCommitAllowed = true,
}: SaveCreditAgreementWipButtonProps) => {
  const isAdminOperationMode = operationMode === 'admin';

  const handleOnClick = () => {
    saveCreditAgreementFullArtifactWip({
      variables: {
        creditAgreementFullArtifactWip: {
          id: creditAgreementFullArtifactWip.id,
          creditFacilityId: creditAgreementFullArtifactWip.creditFacilityId,
          creditAgreement: JSON.stringify(creditAgreementFullArtifactWip),
        },
      },
    });
  };

  if (isAdminOperationMode) {
    return (
      <SaveIconButton
        ariaLabel="Save"
        label="Save"
        isLoading={isSaveCreditAgreementFullArtifactWipLoading}
        onClick={handleOnClick}
        isDisabled={isDisabled}
      />
    );
  }

  return (
    <Button
      border={isCommitAllowed ? '2px' : undefined}
      variant={isCommitAllowed ? 'outline' : 'solid'}
      colorScheme="aurora"
      backgroundColor={isCommitAllowed ? 'white' : colors.aurora[400]}
      padding="10px 24px"
      aria-label="Save"
      isLoading={isSaveCreditAgreementFullArtifactWipLoading}
      onClick={handleOnClick}
      isDisabled={isDisabled}
    >
      Save Progress
    </Button>
  );
};
